import { Controller, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { productFormSchema, ProductFormData } from "./schemas/productFormSchema";
import { use, useEffect, useMemo, useState } from "react";
import { Button, TextField, MenuItem, CircularProgress } from "@mui/material";
import { uploadImageToFirebase } from "../libs/utils";
import ProductDetailForm from "../Forms/ProductDetailForm";
import { useDispatch, useSelector } from "react-redux";
import { fetchCategories } from "../redux/slice/categoriesSlice";
import { addProduct } from "../redux/slice/productlistSlice";
import { WaterDamage } from "@mui/icons-material";
interface ProductFormProps {
  onSubmit: (data: ProductFormData) => void | Promise<void>;
  defaultValues: ProductFormData;
}
const ProductForm = ({onSubmit,defaultValues}:ProductFormProps) => {
     debugger
  const dispatch: any = useDispatch();
  const { items: categories = [], loading: categoriesLoading } = useSelector((state: any) => state.categories);

  const [uploading, setUploading] = useState(false);

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    reset,
    control,
    formState: { errors },
  } = useForm<ProductFormData>({
    resolver: zodResolver(productFormSchema),
    defaultValues: defaultValues ||{
      name: "",
      subtitle: "",
      category: "",
      casNumber: "",
      productDescription: "",
      base64Image: "",
      productDetails: { sections: [] },
    },
  });

  const selectedImage = watch("base64Image");

  useEffect(() => {
    dispatch(fetchCategories());
  }, [dispatch]);

    useEffect(() => {
      if (defaultValues) {
        reset(defaultValues);
      }
    }, [defaultValues, reset]);

    useEffect(() => {
        console.log("Form values changed:", watch());
    }, [watch()]);
    

  const handleImageUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (!file.type.startsWith("image/")) {
      alert("Please select a valid image file.");
      return;
    }

    try {
      setUploading(true);
      const url = await uploadImageToFirebase(file,'product-images');
      setValue("base64Image", url);
    } catch (error) {
      console.error("Image upload failed", error);
      alert("Image upload failed. Please try again.");
    } finally {
      setUploading(false);
    }
  };

  const handlebrochureUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    try {
      setUploading(true);
      const url = await uploadImageToFirebase(file,'product-brochures');
      setValue("brochure", url);
    } catch (error) {
      console.error("Image upload failed", error);
      alert("Image upload failed. Please try again.");
    } finally {
      setUploading(false);
    }
  };

  const handleProductDetailSave = (data: any) => {
    setValue("productDetails", data);
  };

//   const onSubmit = (data: ProductFormData) => {
//     const payload = {
//       ...data,
//       productDetails: data.productDetails ?? { sections: [] },
//     };
//     dispatch(addProduct(payload));
//     alert("Product added successfully!");
//   };

const watchedDetails = watch("productDetails");

const stableDefaultSections = useMemo(() => {
  return watchedDetails;
}, [JSON.stringify(watchedDetails)]);


  return (
    <form onSubmit={handleSubmit(onSubmit)} className="" style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
      <Controller
        name="name"
        control={control}
        render={({ field }) => (
          <TextField
            label="Product Name"
            {...field}
            error={!!errors.name}
            helperText={errors.name?.message}
            fullWidth
          />
        )}
        />

      <Controller
        name="subtitle"
        control={control}
        render={({ field }) => (
            <TextField
                label="Subtitle"
                {...field}
                error={!!errors.subtitle}
                helperText={errors.subtitle?.message}
                fullWidth
            />
            )}
        />

      <Controller
        name="casNumber"
        control={control}
        render={({ field }) => (
          <TextField
            label="CAS Number"
            {...field}
            error={!!errors.casNumber}
            helperText={errors.casNumber?.message}
            fullWidth
          />
        )}      
        />

      <Controller
        name="productDescription"
        control={control}
        render={({ field }) => (
            <TextField
                label="Product Description"
                {...field}
                error={!!errors.productDescription}
                helperText={errors.productDescription?.message}
                fullWidth
                multiline
                rows={4}
            />
            )}
        />

<Controller
  name="category"
  control={control}
  render={({ field }) => (
    <TextField
      select
      label="Category"
      fullWidth
      {...field}
      error={!!errors.category}
      helperText={errors.category?.message}
    >
      <MenuItem value="">Select Category</MenuItem>
      {categories.map((cat: any) => (
        <MenuItem key={cat.id} value={cat.name?.toLowerCase()}>
          {cat.name}
        </MenuItem>
      ))}
    </TextField>
  )}
/>


      <div>
        <input type="file" accept="image/*" onChange={handleImageUpload} />
        {uploading && <CircularProgress size={20} />}
        {selectedImage && <img src={selectedImage} alt="Preview" style={{ width: 100, height: 100 }} />}
        {errors.base64Image && <p style={{ color: "red" }}>{errors.base64Image.message}</p>}
      </div>

      <div>
        <label htmlFor="brochure">Attach brochure</label>
        <input type="file"  name="brochure" id="brochure" onChange={handlebrochureUpload} />
        {/* {uploading && <CircularProgress size={20} />} */}
        {watch("brochure") && 
        <button
      type="button"
      onClick={() => window.open(watch("brochure"), "_blank")}
      style={{ marginTop: "8px", marginLeft: "10px" }}
    >
      Preview Brochure
    </button>}
        {/* {selectedImage && <img src={selectedImage} alt="Preview" style={{ width: 100, height: 100 }} />} */}
        {errors.brochure && <p style={{ color: "red" }}>{errors.brochure.message}</p>}
      </div>

      <ProductDetailForm onSave={handleProductDetailSave} defaultSections = {stableDefaultSections}/>

      <Button type="submit" variant="contained" color="primary">
        Add Product
      </Button>
    </form>
  );
};

export default ProductForm;
